module.exports = __webpack_public_path__ + "images/cam4-lab-assistant-2ec74dba650d1f8cea70cfe3f65b2034.png";